module.exports = __webpack_public_path__ + "img/9_47.b217bccf.png";